/** Only a definite refusal allows the composer to use the text engine. */
export type VoiceMessageDelivery = 'accepted' | 'not_sent' | 'unknown';

export type VoiceMessageSender = (text: string) => VoiceMessageDelivery | Promise<VoiceMessageDelivery>;

/** A native bridge rejection or lost acknowledgement cannot prove non-delivery. */
export async function deliverVoiceMessage(send: VoiceMessageSender, text: string): Promise<VoiceMessageDelivery> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const result = await Promise.race([
      send(text),
      new Promise<VoiceMessageDelivery>(resolve => { timer = setTimeout(() => resolve('unknown'), 10_000); }),
    ]);
    return result === 'accepted' || result === 'not_sent' ? result : 'unknown';
  } catch {
    return 'unknown';
  } finally {
    clearTimeout(timer);
  }
}
